import React from "react";

// Uses flagcdn.com for real flag images — works on all platforms including Windows
// cc = ISO 3166-1 alpha-2 country code (e.g. "fr", "br", "gb-eng")
function Flag({ cc, size = 20, style = {} }) {
  if (!cc) return null;
  const h = Math.round(size * 0.75);
  return (
    <img
      src={"https://flagcdn.com/" + Math.round(size) + "x" + h + "/" + cc.toLowerCase() + ".png"}
      alt={cc}
      width={size}
      height={h}
      style={{ objectFit: "cover", borderRadius: 2, flexShrink: 0, ...style }}
      onError={(e) => { e.target.style.display = "none"; }}
    />
  );
}

export default Flag;
